import Drawer from '@base/Drawer/DrawerWithFooter';
import Image from '@base/FutureImage';
import useOfflineCentreStore from '@stores/city-specific-offline-centres';
import styled from '@emotion/styled';
import Typography from 'aquilla/core/atoms/Typography';
import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import { getAnimationPath } from '@utils/animationHelpers';
import { getFullDate } from '@utils/dates';
import useWindowSize from '@hooks/useWindowSize';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Button from '@base/Button/Button';

const AnimationContainer = styled(LottieAnimation)`
  width: ${Spacings.SPACING_25B};
  height: ${Spacings.SPACING_25B};
`;

const StyDrawer = styled(Drawer)`
  &.MuiDrawer-root > .MuiPaper-root {
    background-color: var(--color-base-0);
  }
`;

const AnimationDiv = styled.div``;

const DrawerWrapper = styled.div`
  grid-column: span 10;
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* &.MuiPopover-root .MuiPaper-root {
    z-index: 2000;
  } */
`;

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 180px;
`;

const Heading = styled(Typography)`
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_3B};
  text-align: center;
`;

const Heading2 = styled(Typography)`
  color: var(--color-text-secondary);
`;
const Heading3 = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
`;
const ContentDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
    background-color: unset;
  }
`;

const Footer = ({ handleButtonClick }) => {
  const { isMobile } = useWindowSize();
  if (!isMobile) return <></>;
  return (
    <FooterWrapper>
      <Button
        label="Got it!"
        color="black"
        onClick={handleButtonClick}
        grid={2}
        width={isMobile ? '100%' : '160px'}
        // variant={showFooterButton ? '' : 'disabled'}
      />
    </FooterWrapper>
  );
};

const AnimationFallBackImage = ({ imageURL }) => {
  return <Image src={imageURL} width={80} height={80} alt="doubt-state-card" />;
};

const VisitBookedForCenter = () => {
  const { isMobile } = useWindowSize();
  const { isVisitBooked, setIsVisitBooked, visitBookedData, bookCentreList } =
    useOfflineCentreStore();
  const centre = bookCentreList.find(
    // eslint-disable-next-line no-shadow
    (centre) => centre.uid === visitBookedData.centreUID
  );
  const epochVisitTIme = visitBookedData.visitTime;
  const closeDrawer = () => {
    setIsVisitBooked(false);
  };
  const loadingStateAnimation = (
    <AnimationContainer
      Fallback={
        <AnimationFallBackImage imageURL="offline-centres/membersAttempting.svg" />
      }
      src={getAnimationPath('offlineCentres/SessionBooked.json')}
    />
  );

  return (
    <StyDrawer
      drawerState={isVisitBooked}
      onClose={closeDrawer}
      footer={<Footer handleButtonClick={closeDrawer} />}
      hideCloseButton={!!isMobile}
    >
      <DrawerWrapper>
        <MainDiv>
          <AnimationDiv>{loadingStateAnimation}</AnimationDiv>
          <Heading variant="h4">Centre Visit booked</Heading>
          <ContentDiv>
            <Heading2 variant="p2">Your visit to&nbsp;</Heading2>
            <Heading3 variant="p2">{centre?.name}</Heading3>
            <Heading2 variant="p2">&nbsp;on&nbsp;</Heading2>
            <Heading3 variant="p2">{getFullDate(epochVisitTIme)} </Heading3>
            <Heading2 variant="p2">&nbsp;is confirmed.</Heading2>
          </ContentDiv>
        </MainDiv>
      </DrawerWrapper>
    </StyDrawer>
  );
};

export default VisitBookedForCenter;
